module.exports = __webpack_public_path__ + "static/media/mail.67fb9ad2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/mail.svg
// module id = 1329
// module chunks = 0